export default "__VITE_ASSET__CYGI2eHY__"